import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from '../../core/services/modal.service';

@Component({
	selector: 'app-interstitial-modal',
	templateUrl: './interstitial-modal.component.html',
	styleUrls: ['./interstitial-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class InterstitialModalComponent {
	@Input() modalId;

	@Input() text;

	@Input() subText;

	@Input() user;

	@Input() url;

	@Input() confirmButtonText;

	public success;

	constructor(
		private ms: ModalService,
		private router: Router,
	) { }

	upgrade() {
		this.router.navigate([`/author-dashboard/${this.user.authorLink}/subscriptions`]).then();
		this.ms.close(this.modalId);
	}

	cancel() {
		this.ms.close(this.modalId);
	}
}
